export function availableEmergencyFund(availableFunds: number) {
  return function (fieldValue: string) {
    const strippedFieldValue = fieldValue && fieldValue.replace(/[,]/g, '');
    const fieldValueNumber = Number(strippedFieldValue) * 100;
    const exceedAvailableFunds = fieldValueNumber > availableFunds;

    return exceedAvailableFunds ? 'Cannot exceed available funds' : undefined;
  };
}
